import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";

import "./App.css";

import Layout from "./pages/Layout";
import Login from "./pages/Login/Login";
import UsersTab from "./pages/Dashboard/tabs/UsersTab";
import UsersAdminTab from "./pages/Dashboard/tabs/UsersAdminTab";
import AdminLayout from "./pages/Dashboard/AdminLayout";
import PageProfile from "./composant/PageProfile";
import Leaderboard from "./pages/Leaderboard";
import BadgesTab from "./pages/Dashboard/tabs/BadgesTab";
import CategoriesTab from "./pages/Dashboard/tabs/CategoriesTab";
import Logout from "./pages/Logout";
import ProtectedRoute from "./policies/ProtectedRoute";
import Role from "./policies/Role";
import Signup from "./pages/Signup/Signup";
import { BadgeListContextProvider } from "./context/BadgeListContext";
import { BackgroundContextProvider } from "./context/BackgroundContext";
import Home from "./pages/Home/Home";
import ListeBadge from "./pages/ListeBadge";
import TeacherCodesTab from "./pages/Dashboard/tabs/TeacherCodesTab";
import PageUser from "./pages/PageUser";
import DefaultTheme from "./theme";
import PageProfileModify from "./composant/Forms/PageProfileModify";
import Contact from "./pages/Contact";
import TopCollectors from "./pages/Dashboard/Tops_score/TopCollectors";
import TopByCategory from "./pages/Dashboard/Tops_score/TopByCategory";
import Confidentiality from "./pages/Confidentiality";
import BadgeAssignation from "./pages/BadgeAssignation";
import AdminHomePanel from "./pages/Home/components/AdminHomePanel";

function App() {
  const { user, loading } = useAuth();

  if (loading) return null;

  const isAdmin =
    user?.role === Role.Admin || user?.role === Role.AdminContact;

  const isTeacher = user?.role === Role.Teacher;

  const shouldGoToAdmin = false;

  return (
    <BrowserRouter>
      <DefaultTheme>
        <BackgroundContextProvider>
          <BadgeListContextProvider>
            <Routes>
              {/* ROUTES PUBLIQUES */}
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/logout" element={<Logout />} />
              <Route path="/auth/signup" element={<Signup />} />
              <Route
                path="/politique-de-confidentialite"
                element={<Confidentiality />}
              />

              {/* ROUTE PRINCIPALE */}
              <Route
                path="/"
                element={
                  user ? (
                    shouldGoToAdmin ? (
                      <Navigate to="/admin" replace />
                    ) : (
                      <Layout />
                    )
                  ) : (
                    <Login />
                  )
                }
              >
                <Route index element={<Home />} />
                <Route path="assigner-badges" element={<BadgeAssignation />} />
                <Route path="modify-profile" element={<PageProfileModify />} />
                <Route path="leaderboard" element={<Leaderboard />} />
                <Route path="badges" element={<ListeBadge />} />
                <Route path="utilisateur/:id" element={<PageUser />} />
                <Route path="profile" element={<PageProfile />} />
              </Route>

              {/* SITE NORMAL POUR Utilisateurs */}
              <Route
                path="/site"
                element={user ? <Layout /> : <Navigate to="/auth/login" replace />}
              >
                <Route index element={<Home />} />
                <Route path="assigner-badges" element={<BadgeAssignation />} />
                <Route path="modify-profile" element={<PageProfileModify />} />
                <Route path="leaderboard" element={<Leaderboard />} />
                <Route path="badges" element={<ListeBadge />} />
                <Route path="utilisateur/:id" element={<PageUser />} />
                <Route path="profile" element={<PageProfile />} />
                <Route path="*" element={<h1>404: Page non trouvée</h1>} />
              </Route>

              {/* ADMIN / PROF */}
              <Route
              path="/admin"
              element={ProtectedRoute([Role.Admin, Role.AdminContact, Role.Teacher])}
              >
              <Route element={<AdminLayout />}>
                <Route index element={<AdminHomePanel />} />

                <Route path="users" element={<UsersTab />} />
                <Route path="admin_users" element={<UsersAdminTab />} />
                <Route path="badges" element={<BadgesTab />} />
                <Route path="categories" element={<CategoriesTab />} />
                <Route path="top-collectors" element={<TopCollectors />} />
                <Route path="top-by-category" element={<TopByCategory />} />

                <Route element={ProtectedRoute([Role.Admin, Role.AdminContact])}>
                  <Route path="teacher_codes" element={<TeacherCodesTab />} />
                </Route>
              </Route>
              </Route>

              {/* FALLBACK */}
              <Route
                path="*"
                element={
                  user ? (
                    shouldGoToAdmin ? (
                      <Navigate to="/admin" replace />
                    ) : (
                      <Navigate to="/" replace />
                    )
                  ) : (
                    <Navigate to="/auth/login" replace />
                  )
                }
              />
            </Routes>
          </BadgeListContextProvider>
        </BackgroundContextProvider>
      </DefaultTheme>
    </BrowserRouter>
  );
}

export default App;